import { AvailableStagingsListContextProvider, GalleryStagingFlowContextProvider, GalleryStagingStackProvider } from 'components/pages/Gallery/common'
import { GalleryAdditionalVisualsContextProvider, GalleryAssignmentContextProvider, GalleryConstantsContextProvider, GalleryDealContextProvider, GalleryOrderContextProvider, GalleryProductContextProvider, GalleryVirtualVisitContextProvider, GalleryVisualSelectionContextProvider, GalleryVisualTypeContextProvider, GalleryVisualsContextProvider, GalleryVisualsDownloadArchiveContextProvider, GalleryVisualsEditingStackProvider, GalleryVisualsFileAPIProvider, GalleryVisualsMetaContextProvider } from 'components/pages/Gallery/_main/contexts'
import { useLocation, useParams } from 'react-router-dom'

import { ClientGalleryContextProvider } from 'components/pages/Gallery/_main/ClientGallery/_main'
import { ClientPropertyGalleryStagingFlowPage } from './ClientPropertyGalleryStagingFlowPage.page'
import { FC } from 'react'
import { GalleryStagingContextProvider } from 'components/pages/Gallery/pages/GalleryStaging'

export const ClientPropertyStaging: FC = () => {
  const { assignmentId } = useParams<{ id?: string, assignmentId?: string }>()
  const location = useLocation()

  if (!assignmentId) return null

  return (
    <GalleryConstantsContextProvider>
      <GalleryAssignmentContextProvider assignmentId={assignmentId}>
        <GalleryDealContextProvider assignmentId={assignmentId} keepPreviousData={true}>
          <GalleryVisualTypeContextProvider assignmentId={assignmentId}>
            <GalleryProductContextProvider assignmentId={assignmentId}>
              <GalleryOrderContextProvider assignmentId={assignmentId}>
                <GalleryVisualsMetaContextProvider assignmentId={assignmentId}>
                  <GalleryVisualsFileAPIProvider assignmentId={assignmentId}>
                  <GalleryVisualsContextProvider assignmentId={assignmentId}>
                    <GalleryVirtualVisitContextProvider assignmentId={assignmentId}>
                      <GalleryVisualSelectionContextProvider assignmentId={assignmentId}>
                        <GalleryAdditionalVisualsContextProvider assignmentId={assignmentId}>
                          <GalleryVisualsDownloadArchiveContextProvider assignmentId={assignmentId}>
                            <GalleryVisualsEditingStackProvider assignmentId={assignmentId}>
                              <GalleryStagingStackProvider>
                                <GalleryStagingFlowContextProvider>
                                  <GalleryStagingContextProvider>
                                    <AvailableStagingsListContextProvider>
                                      <ClientGalleryContextProvider assignmentId={assignmentId}>

                                        <ClientPropertyGalleryStagingFlowPage stagingAssignments={location.state.stagingAssignments} />

                                      </ClientGalleryContextProvider>
                                    </AvailableStagingsListContextProvider>
                                  </GalleryStagingContextProvider>
                                </GalleryStagingFlowContextProvider>
                              </GalleryStagingStackProvider>
                            </GalleryVisualsEditingStackProvider>
                          </GalleryVisualsDownloadArchiveContextProvider>
                        </GalleryAdditionalVisualsContextProvider>
                      </GalleryVisualSelectionContextProvider>
                    </GalleryVirtualVisitContextProvider>
                  </GalleryVisualsContextProvider>
                  </GalleryVisualsFileAPIProvider>
                </GalleryVisualsMetaContextProvider>
              </GalleryOrderContextProvider>
            </GalleryProductContextProvider>
          </GalleryVisualTypeContextProvider>
        </GalleryDealContextProvider>
      </GalleryAssignmentContextProvider>
    </GalleryConstantsContextProvider>
  )
}
